import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFileTypeXls = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 4a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v4a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4zm8 1.414L16.586 7H15zM3.445 14.168a1 1 0 0 1 1.387.277L6 16.197l1.168-1.752a1 1 0 0 1 1.664 1.11L7.202 18l1.63 2.445a1 1 0 0 1-1.664 1.11L6 19.803l-1.168 1.752a1 1 0 0 1-1.664-1.11L4.798 18l-1.63-2.445a1 1 0 0 1 .277-1.387M11 14a1 1 0 0 1 1 1v5h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1m5.586.586A2 2 0 0 1 18 14h1.25A1.75 1.75 0 0 1 21 15.75a1 1 0 0 1-1.968.25H18v1h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1.25A1.75 1.75 0 0 1 16 20.25 1 1 0 0 1 17.97 20H19v-1h-1a2 2 0 0 1-2-2v-1a2 2 0 0 1 .586-1.414"
            clipRule="evenodd"
        />
    </svg>
);
